module.exports = __webpack_public_path__ + "static/img/conf_settings.0d4255b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conf_settings.svg
// module id = YefP
// module chunks = 1